import React, { useState, useEffect } from 'react';

const UserForm = ({ isOpen, onClose, onSubmit, formData, setFormData, isEditing, departments, roles, degrees, academicTitles, currentUser }) => {
    const [showPassword, setShowPassword] = useState(false);
    const [showConfirmPassword, setShowConfirmPassword] = useState(false);

    const handleChange = (e) => {
        const { name, value, type, checked } = e.target;
        setFormData({ ...formData, [name]: type === 'checkbox' ? checked : value });
    };

    const selectedDeptId = parseInt(formData.DepartmentId);
    const selectedDept = departments.find(d => d.Id === selectedDeptId);
    const isRootDept = selectedDept ? (selectedDept.ParentId === null || selectedDept.ParentId === undefined) : false;

    const selectedDeptName = selectedDept ? selectedDept.Name : '';
    const isReadyForScv = formData.LastName && formData.FirstName && formData.DepartmentId;

    const availableRoles = roles;

    const selectedRole = roles.find(r => r.Id === parseInt(formData.RoleId));
    const isEditingManager = selectedRole && selectedRole.Name.toLowerCase().includes('quản lý khoa');
    const isCurrentUserAdmin = currentUser?.RoleId === 1 || (currentUser?.RoleName || '').toLowerCase() === 'quản trị viên' || currentUser?.RoleName === 'Admin';
    const showDelegationCheckbox = isCurrentUserAdmin && isEditingManager && !isRootDept;

    const renderDeptTree = (parentId = null, level = 0) => {
        return departments
            .filter(d => d.ParentId === parentId)
            .map(d => (
                <React.Fragment key={`form-dept-${d.Id}`}>
                    <option value={d.Id}>{'\u00A0'.repeat(level * 4)}{level > 0 ? '˪ ' : ''}{d.Name}</option>
                    {renderDeptTree(d.Id, level + 1)}
                </React.Fragment>
            ));
    };

    const handleClose = () => {
        setShowPassword(false);
        setShowConfirmPassword(false);
        onClose();
    };

    if (!isOpen) return null;

    return (
        <div className="modal-overlay" style={{ zIndex: 1000 }}>
            <div className="modal-box form-modal-box" style={{ maxHeight: '95vh', overflowY: 'auto' }}>

                <div className="modal-header" style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start' }}>
                    <h3 style={{ margin: 0, paddingRight: '15px', lineHeight: '1.4' }}>
                        {isEditing ? "Cập nhật người dùng" : "Thêm mới người dùng"}
                    </h3>
                    <button className="close-btn" onClick={handleClose} style={{ fontSize: '26px', lineHeight: '1', display: 'flex', flexShrink: 0, marginTop: '-2px' }}>
                        &times;
                    </button>
                </div>

                <div className="modal-body" style={{ padding: '25px' }}>
                    <form id="userForm" onSubmit={onSubmit}>
                        <div style={{ display: 'flex', flexWrap: 'wrap', gap: '20px', marginBottom: '20px' }}>
                            <div className="form-group" style={{ flex: '1 1 250px' }}>
                                <label style={{ display: 'block', marginBottom: '8px', fontWeight: '500' }}>Tên đăng nhập *</label>
                                <input type="text" name="Username" className="form-input" value={formData.Username} onChange={handleChange} required disabled={isEditing} />
                            </div>

                            <div className="form-group" style={{ flex: '1 1 250px' }}>
                                <label style={{ display: 'block', marginBottom: '8px', fontWeight: '500' }}>Mật khẩu {isEditing ? "" : "*"}</label>
                                <div style={{ position: 'relative' }}>
                                    <input
                                        type={showPassword ? "text" : "password"}
                                        name="Password"
                                        className="form-input"
                                        value={formData.Password || ''}
                                        onChange={handleChange}
                                        required={!isEditing}
                                        placeholder={isEditing ? "Bỏ trống nếu không đổi mật khẩu" : "Nhập mật khẩu"}
                                        style={{ width: '100%', paddingRight: '40px' }}
                                    />
                                    <i
                                        className={`fa-solid ${showPassword ? 'fa-eye-slash' : 'fa-eye'}`}
                                        style={{ position: 'absolute', right: '12px', top: '50%', transform: 'translateY(-50%)', cursor: 'pointer', color: '#666' }}
                                        onClick={() => setShowPassword(!showPassword)}
                                        title={showPassword ? "Ẩn mật khẩu" : "Hiện mật khẩu"}
                                    ></i>
                                </div>
                            </div>

                            <div className="form-group" style={{ flex: '1 1 250px' }}>
                                <label style={{ display: 'block', marginBottom: '8px', fontWeight: '500' }}>Xác nhận mật khẩu {isEditing ? "" : "*"}</label>
                                <div style={{ position: 'relative' }}>
                                    <input
                                        type={showConfirmPassword ? "text" : "password"}
                                        name="ConfirmPassword"
                                        className="form-input"
                                        value={formData.ConfirmPassword || ''}
                                        onChange={handleChange}
                                        required={!isEditing}
                                        placeholder={isEditing ? "Bỏ trống nếu không đổi mật khẩu" : "Xác nhận mật khẩu"}
                                        style={{ width: '100%', paddingRight: '40px' }}
                                    />
                                    <i
                                        className={`fa-solid ${showConfirmPassword ? 'fa-eye-slash' : 'fa-eye'}`}
                                        style={{ position: 'absolute', right: '12px', top: '50%', transform: 'translateY(-50%)', cursor: 'pointer', color: '#666' }}
                                        onClick={() => setShowConfirmPassword(!showConfirmPassword)}
                                        title={showConfirmPassword ? "Ẩn mật khẩu" : "Hiện mật khẩu"}
                                    ></i>
                                </div>
                            </div>
                        </div>

                        <div style={{ display: 'flex', flexWrap: 'wrap', gap: '20px', marginBottom: '15px' }}>
                            <div className="form-group" style={{ flex: '1 1 300px' }}>
                                <label style={{ display: 'block', marginBottom: '8px', fontWeight: '500' }}>Họ và tên đệm *</label>
                                <input type="text" name="LastName" className="form-input" value={formData.LastName} onChange={handleChange} required />
                            </div>
                            <div className="form-group" style={{ flex: '1 1 300px' }}>
                                <label style={{ display: 'block', marginBottom: '8px', fontWeight: '500' }}>Tên *</label>
                                <input type="text" name="FirstName" className="form-input" value={formData.FirstName} onChange={handleChange} required />
                            </div>

                            <div className="form-group" style={{ flex: '1 1 300px' }}>
                                <label style={{ display: 'block', marginBottom: '8px', fontWeight: '500' }}>Học vị *</label>
                                <select name="DegreeId" className="form-input" value={formData.DegreeId} onChange={handleChange} required>
                                    <option value="">Chọn học vị</option>
                                    {degrees.map(deg => <option key={deg.Id} value={deg.Id}>{deg.Name}</option>)}
                                </select>
                            </div>

                            <div className="form-group" style={{ flex: '1 1 300px' }}>
                                <label style={{ display: 'block', marginBottom: '8px', fontWeight: '500' }}>Chức danh nghề nghiệp</label>
                                <select name="AcademicTitleId" className="form-input" value={formData.AcademicTitleId} onChange={handleChange}>
                                    <option value="">Chọn chức danh</option>
                                    {academicTitles.map(title => <option key={title.Id} value={title.Id}>{title.Name}</option>)}
                                </select>
                            </div>

                            <div className="form-group" style={{ flex: '1 1 300px' }}>
                                <label style={{ display: 'block', marginBottom: '8px', fontWeight: '500' }}>Học hàm</label>
                                <select name="AcademicRank" className="form-input" value={formData.AcademicRank || ''} onChange={handleChange}>
                                    <option value="">Chọn học hàm (nếu có)</option>
                                    <option value="Giáo sư">Giáo sư</option>
                                    <option value="Phó giáo sư">Phó giáo sư</option>
                                </select>
                            </div>

                            <div className="form-group" style={{ flex: '1 1 300px' }}>
                                <label style={{ display: 'block', marginBottom: '8px', fontWeight: '500' }}>Giới tính *</label>
                                <select name="Gender" className="form-input" value={formData.Gender} onChange={handleChange} required>
                                    <option value="Nam">Nam</option>
                                    <option value="Nữ">Nữ</option>
                                    <option value="Khác">Khác</option>
                                </select>
                            </div>
                            <div className="form-group" style={{ flex: '1 1 300px' }}>
                                <label style={{ display: 'block', marginBottom: '8px', fontWeight: '500' }}>Đơn vị công tác *</label>
                                <select name="DepartmentId" className="form-input" value={formData.DepartmentId} onChange={handleChange} required>
                                    <option value="">Chọn đơn vị</option>
                                    {renderDeptTree()}
                                </select>
                            </div>

                            <div className="form-group" style={{ flex: '1 1 300px' }}>
                                <label style={{ display: 'block', marginBottom: '8px', fontWeight: '500' }}>Email *</label>
                                <input type="email" name="Email" className="form-input" value={formData.Email} onChange={handleChange} required />
                            </div>
                            <div className="form-group" style={{ flex: '1 1 300px' }}>
                                <label style={{ display: 'block', marginBottom: '8px', fontWeight: '500' }}>Điện thoại *</label>
                                <input type="text" name="Phone" className="form-input" value={formData.Phone} onChange={handleChange} required />
                            </div>

                            <div className="form-group" style={{ flex: '1 1 100%' }}>
                                <label style={{ display: 'block', marginBottom: '8px', fontWeight: '500' }}>Địa chỉ *</label>
                                <input type="text" name="Address" className="form-input" value={formData.Address} onChange={handleChange} required />
                            </div>

                            <div className="form-group" style={{ flex: '1 1 300px' }}>
                                <label style={{ display: 'block', marginBottom: '8px', fontWeight: '500' }}>Vai trò *</label>
                                <select name="RoleId" className="form-input" value={formData.RoleId} onChange={handleChange} required>
                                    <option value="">Chọn vai trò</option>
                                    {availableRoles.map(role => <option key={role.Id} value={role.Id}>{role.Name}</option>)}
                                </select>
                            </div>

                            {isEditingManager && (
                                <div className="form-group" style={{ flex: '1 1 300px' }}>
                                    <label style={{ display: 'block', marginBottom: '8px', fontWeight: 'bold', color: '#e74c3c' }}>Phạm vi dữ liệu Quản lý</label>
                                    <select name="ManagedDepartmentId" className="form-input" value={formData.ManagedDepartmentId} onChange={handleChange}>
                                        <option value="">Mặc định (Quản lý theo đơn vị công tác)</option>
                                        <option value="0">Quản lý Toàn trường (Tất cả đơn vị)</option>
                                        {renderDeptTree()}
                                    </select>
                                    <small style={{ color: '#666', fontStyle: 'italic', display: 'block', marginTop: '4px' }}>Dùng để phân quyền xem/thống kê dữ liệu, độc lập với đơn vị công tác phía trên</small>
                                </div>
                            )}

                            <div className="form-group" style={{ flex: '1 1 100%', display: 'flex', flexWrap: 'wrap', alignItems: 'center', gap: '20px', background: '#f8f9fa', padding: '15px', borderRadius: '5px', border: '1px solid #e9ecef' }}>
                                <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                                    <input type="checkbox" name="IsActive" checked={formData.IsActive} onChange={handleChange} style={{ width: '18px', height: '18px', cursor: 'pointer' }} />
                                    <label style={{ margin: 0, fontWeight: 'bold', color: '#28a745', cursor: 'pointer' }}>Kích hoạt tài khoản</label>
                                </div>

                                {showDelegationCheckbox && (
                                    <div style={{ display: 'flex', alignItems: 'center', gap: '10px', paddingLeft: '15px', borderLeft: '2px solid #ccc' }}>
                                        <input type="checkbox" name="IsDelegatedAdmin" checked={formData.IsDelegatedAdmin} onChange={handleChange} style={{ width: '18px', height: '18px', cursor: 'pointer' }} />
                                        <label style={{ margin: 0, fontWeight: 'bold', color: '#0056b3', cursor: 'pointer' }}>
                                            Cho phép đồng cấp quản lý
                                        </label>
                                    </div>
                                )}
                            </div>
                        </div>

                        {isReadyForScv && (
                            <div style={{ marginTop: '20px', padding: '15px', backgroundColor: '#e8f4fd', borderRadius: '5px', border: '1px solid #b8daff', display: 'flex', alignItems: 'center', gap: '15px' }}>
                                <i className="fa-solid fa-cloud-arrow-down" style={{ color: '#0056b3', fontSize: '24px' }}></i>
                                <div>
                                    <strong style={{ color: '#0056b3', display: 'block', marginBottom: '3px' }}>Đã cấu hình tự động đồng bộ SCV</strong>
                                    <span style={{ fontSize: '13px', color: '#333' }}>
                                        Hệ thống sẽ gán cứng Họ tên: <b>{formData.LastName} {formData.FirstName}</b> và Đơn vị: <b>{selectedDeptName}</b>. Giảng viên này có thể trích xuất SCV chính xác (chống trùng tên) ngay sau khi đăng nhập.
                                    </span>
                                </div>
                            </div>
                        )}

                    </form>
                </div>
                <div className="modal-footer" style={{ borderTop: '1px solid #e2e8f0', padding: '15px 25px' }}>
                    <button type="button" className="btn-cancel" onClick={handleClose}>Hủy</button>
                    <button type="submit" form="userForm" className="btn-submit">Hoàn tất</button>
                </div>
            </div>
        </div>
    );
};

export default UserForm;